import React, { useEffect, useState, createRef, useRef } from 'react';
import { Container, Row, Col, InputGroup, Form } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import moment from 'moment';
//import { parseISO, format } from 'date-fns';
import Header from '../common/Header/Header';
import { ActionMenus } from '../common/ActionMenu';
import GenericButton from '../common/button/GenericButton/GenericButton';
import TextInput from 'src/Admin/components/common/text-input';
import { SearchSVG } from 'src/Admin/img/SearchSVG';
import TrashIcon from 'src/Admin/img/search-claims/trash';
import CarrotDownIcon from 'src/Admin/img/search-claims/carrot-down';
import CommonGenericButton from 'src/Components/GenericButton/GenericButton';
import CheckboxInput from 'src/Member/components/common/checkbox';
import {
  valuesList as defaultValuesList,
  criteriaMenuItems,
  memberTypeOptions,
  criteriaDefaultValues,
  providerTypeOptions,
  searchByProviderOptions,
  claimDateSearchByOptions,
  claimDateDateRangeOptions,
} from './values-list';
import AutoSuggestionSelectComponent from '../common/AutoSuggestSelect/Select';
import { resetSearchParams } from 'src/redux/admin/claimsSlice';
//#TODO: use below component for search sugesstions on Specialties
//import AutoSuggestionAsyncSelectComponent from '../common/AutoSuggestSelect/Select';
import { SpecialtySelectInput } from './SpecialtySelectInput';
import DatePicker from '../common/DatePicker';
import ToastMessage from '../common/ToastMessage';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import { axiosInstance } from 'src/api/axios';
import 'react-web-tabs/dist/react-web-tabs.css';
import './searchClaims.scss';
import { CrossIcon } from 'src/Admin/img/myProfile/CrossIcon';
import MasterPermissions from '../../api/MasterPermissions';
import FilterModal from '../common/filter-modal/FilterModal';
import AddButton from '../User/UserFormNew/components/AddButton';
import ProviderSideModal from './SideModals/ProviderSideModal';
import SelectedItemComponent from './SideModals/SelectedItemComponent';
import MemberSideModal from './SideModals/MemberSideModal';
import MemberSelectedItemComponent from './SideModals/MemberSelectedItemComponent';

//criteria context menu

const ActionMenuItem = ({ label, onClick, className }) => {
  return (
    <div className={`criteria-menu-item ${className}`}>
      <GenericButton
        className="pl-0 criteria-menu-item-btn"
        variant="link"
        onClick={onClick}
      >
        {label}
      </GenericButton>
    </div>
  );
};

//For Member/Dependent search
//const permissionForMemberDependentSearch =
//MasterPermissions.CheckPermission('Member Information');

//criteria selectable container heading

const InputsBlockHeading = (props) => {
  const { label, subText, RightComponent } = props;

  return (
    <div className="heading-container d-flex flex-row justify-content-between">
      <div className="left-container">
        {label && <h4 className="selectable-list-heading">{label}</h4>}

        {subText && <span className="heading-sub-text">{subText}</span>}
      </div>

      {RightComponent && (
        <div className="right-container">
          <RightComponent />
        </div>
      )}
    </div>
  );
};

//criteria selectable container

const ProviderPermissionsList = (isSuperUser) => {
  const providerMandatoryFields = [];
  MasterPermissions.CheckPermission('Physician Name') &&
    providerMandatoryFields.push('name');
  MasterPermissions.CheckPermission('Facility Name') &&
    providerMandatoryFields.push('facility_name');
  MasterPermissions.CheckPermission('NPI') &&
    providerMandatoryFields.push('npi');
  MasterPermissions.CheckPermission('Tax ID') &&
    providerMandatoryFields.push('tax_id');
  MasterPermissions.CheckPermission('Specialty') &&
    providerMandatoryFields.push('specialty');

  if (isSuperUser) {
    return [];
  }
  return providerMandatoryFields;
};

const MemberPermissionsList = (isSuperUser) => {
  const memberMandatoryFields = [];
  //member Info
  MasterPermissions.CheckPermission('Member First Name') &&
    memberMandatoryFields.push('first_name');
  MasterPermissions.CheckPermission('Member Last Name') &&
    memberMandatoryFields.push('last_name');
  MasterPermissions.CheckPermission('Claims Member ID') &&
    memberMandatoryFields.push('member_id');
  MasterPermissions.CheckPermission('Claims Member Date of Birth') &&
    memberMandatoryFields.push('dob');

  if (isSuperUser) {
    return [];
  }
  return memberMandatoryFields;
};

const sccfPermissionsList = (isSuperUser) => {
  const sccfMandatoryField = [];
  MasterPermissions.CheckPermission('SCCF#') && sccfMandatoryField.push('sccf');

  if (isSuperUser) {
    return [];
  }
  return sccfMandatoryField;
};

const claimnoPermissionsList = (isSuperUser) => {
  const claimnoMandatoryField = [];
  MasterPermissions.CheckPermission('Claim Number') &&
    claimnoMandatoryField.push('claim-number');
  if (isSuperUser) {
    return [];
  }
  return claimnoMandatoryField;
};

const CriteriaSelectableComponentWrapper = (props) => {
  const { handleDeleteCriteria, showDeleteIcon = true } = props;

  return (
    <Row
      className={`mx-0 criteria-selection-block ${
        props.wrapperClassName ? props.wrapperClassName : ''
      }`}
    >
      <Col className="p-0">
        <div
          className={`criteria-selection-block-content selection-block ${
            !showDeleteIcon ? 'top-right-br bottom-right-br' : ''
          }`}
        >
          {props.children}
        </div>

        {showDeleteIcon && (
          <div className="criteria-selection-block-action selection-block">
            <GenericButton
              className="pl-0 delete-cliteria-btn"
              variant="link"
              onClick={handleDeleteCriteria}
            >
              <TrashIcon />
            </GenericButton>
          </div>
        )}
      </Col>
    </Row>
  );
};

const ManageClaims = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const searchMemberBtnRef = useRef(null);
  const searchProviderBtnRef = useRef(null);

  const { Default_Time_Format } = useSelector(
    ({ app }) => app?.appConfigs?.Time_Setting || 'mm/dd/yyyy',
  );

  //GET Redux state
  const loggedInUserType = useSelector(({ user }) => user.userData?.UserType);
  const isSuperUser = useSelector(({ user }) => user.userData?.SuperUser);
  const [selectedCriteriaList, setSelectedCriteriaList] = useState([]);
  const [isSearchBtnDisable, setisSearchBtnDisable] = useState(true);
  const [isMemberSearchBtnDisable, setIsMemberSearchBtnDisable] =
    useState(false);
  const [dataFetching, setDataFetching] = useState(false);
  const [isServerError, setIsServerError] = useState(false);
  const [userEnteredCriteriaValues, setUserEnteredCriteriaValues] = useState(
    {},
  );
  const {
    blockOfBusiness,
    location: locBreadCrumb,
    employer: employerBreadCrumb,
  } = useSelector((state) => state.breadCrumb);
  const bob = blockOfBusiness.key;
  const locations = locBreadCrumb.key;
  const employer = employerBreadCrumb.key;
  const [selectedDateTypeValues, setSelectedDateTypeValues] = useState([]);
  //const [statusesList, setStatusesList] = useState([]);
  const [statusesListRaw, setStatusesListRaw] = useState([]);
  const [valuesList, setValuesList] = useState({
    'claim-status': defaultValuesList['claim-status'],
    products: [...defaultValuesList.products],
  });
  const [fomattedStatusesObject, setFomattedStatusesObject] = useState({});
  const [providerDetailsToSearch, setProviderDetailsToSearch] = useState({}); //type and commar separated ids to search
  const [memberIdsToSearch, setMemberIdsToSearch] = useState({}); //type and comma separated ids to search

  const [providerPermissionsListArray, setProviderPermissionsListArray] =
    useState([]);
  const [memberPermissionsListArray, setmemberPermissionsListArray] = useState(
    [],
  );
  const [sccfPermissionsListArray, setsccfPermissionsListArray] = useState([]);
  const [claimnoPermissionsListArray, setclaimnoPermissionsListArray] =
    useState([]);

  const [
    checkMinSearchCriteriaExplicitely,
    setCheckMinSearchCriteriaExplicitely,
  ] = useState(false);

  useEffect(() => {
    dispatch(resetSearchParams());
  }, []);

  useEffect(() => {
    navigate('.', {
      replace: true,
      state: {
        selectedCriteriaList: selectedCriteriaList,
        searchCriteria: userEnteredCriteriaValues,
        selectedDateTypeValues: selectedDateTypeValues,
      },
    });
    validateMinSearchCriteria();
    handleDisableSearchBtn();
    handleDisableMemberSearchBtn();
    handleDisableProviderSearchBtn();
  }, [
    selectedCriteriaList,
    userEnteredCriteriaValues,
    selectedMemberDataLocal,
    selectedProviderDataLocal,
  ]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const {
      searchCriteria,
      selectedCriteriaList: alreadySelectedCriteriaList,
      selectedDateTypeValues,
      providerSelectedValue,
      memberSelectedValue,
      isComingFromSearchResult,
    } = location.state || {};
    console.warn('****** >>>>> ', searchCriteria);
    if (isComingFromSearchResult === true) {
      setSelectedProviderDataLocal(providerSelectedValue);
      setSelectedMemberDataLocal(memberSelectedValue);
    }

    //provider-info
    //Clearing previous claims pagination store
    dispatch(resetSearchParams());
  }, []);

  //state to hold number of items for which default calculation is done
  //const [defaultCalculated, setDefaultCalculated] = useState([]);

  const providerDefault = () => {
    //if (!defaultCalculated.includes('provider')) {
    //setDefaultCalculated([...defaultCalculated, 'provider']);
    //}
    const PermissionsListArray = ProviderPermissionsList(isSuperUser);
    if (PermissionsListArray?.length > 0) {
      setProviderPermissionsListArray(PermissionsListArray);
      setSelectedCriteriaList(
        [...criteriaMenuItems].filter(
          (val) => val.value === 'provider-information',
        ),
      );

      setUserEnteredCriteriaValues({
        ['provider-information']: [
          { ...criteriaDefaultValues['provider-information'] },
        ],
      });
    }
  };

  const memberDefault = () => {
    const memberPermissionsListArray = MemberPermissionsList(isSuperUser);
    if (memberPermissionsListArray?.length > 0) {
      setmemberPermissionsListArray(memberPermissionsListArray);
      const defaultCriteria = [...criteriaMenuItems].filter(
        (val) => val.value === 'member-information',
      );
      setSelectedCriteriaList((prev) => {
        return [...prev, ...defaultCriteria];
      });

      setUserEnteredCriteriaValues((prev) => {
        return {
          ...prev,
          ['member-information']: [
            { ...criteriaDefaultValues['member-information'] },
          ],
        };
      });
    }
    //if (!defaultCalculated.includes('member')) {
    //setDefaultCalculated([...defaultCalculated, 'member']);
    //}
  };

  const sccfDefault = () => {
    const sccfPermissionsListArray = sccfPermissionsList(isSuperUser);
    if (sccfPermissionsListArray?.length > 0) {
      setsccfPermissionsListArray(sccfPermissionsListArray);
      const defaultCriteria = [...criteriaMenuItems].filter(
        (val) => val.value === 'sccf',
      );
      setSelectedCriteriaList((prev) => {
        return [...prev, ...defaultCriteria];
      });

      setUserEnteredCriteriaValues((prev) => {
        return {
          ...prev,
          sccf: criteriaDefaultValues['sccf'],
        };
      });
    }
    //if (!defaultCalculated.includes('sccf')) {
    //setDefaultCalculated([...defaultCalculated, 'sccf']);
    //}
  };

  const claimNumberDefault = () => {
    const claimPermissionsListArray = claimnoPermissionsList(isSuperUser);
    if (claimPermissionsListArray?.length > 0) {
      setclaimnoPermissionsListArray(claimPermissionsListArray);
      const defaultCriteria = [...criteriaMenuItems].filter(
        (val) => val.value === 'claim-number',
      );
      setSelectedCriteriaList((prev) => {
        return [...prev, ...defaultCriteria];
      });

      setUserEnteredCriteriaValues((prev) => {
        return {
          ...prev,
          'claim-number': criteriaDefaultValues['claim-number'],
        };
      });
    }
    //if (!defaultCalculated.includes('claim-number')) {
    //setDefaultCalculated([...defaultCalculated, 'claim-number']);
    //}
  };

  useEffect(() => {
    const {
      searchCriteria,
      selectedCriteriaList: alreadySelectedCriteriaList,
      selectedDateTypeValues,
      providerSelectedValue,
      isComingFromSearchResult,
    } = location.state || {};
    console.warn('****** >>>>> ', searchCriteria);
    if (isComingFromSearchResult === true) {
      setSelectedProviderDataLocal(providerSelectedValue);
    }

    //provider-info
    providerDefault();
    //member-info
    memberDefault();

    //sccf
    sccfDefault();

    //claim number
    claimNumberDefault();

    if (searchCriteria) {
      if (Object.keys(searchCriteria).length > 0) {
        setUserEnteredCriteriaValues(searchCriteria);
        setSelectedCriteriaList(alreadySelectedCriteriaList);
        if (searchCriteria['claim-date']) {
          setTotalDateInputsSelected(searchCriteria['claim-date']?.length || 0);
        }
      }
    }
    if (selectedDateTypeValues?.length > 0) {
      setSelectedDateTypeValues(selectedDateTypeValues);
    }
  }, []);

  useEffect(() => {
    const obj = {};
    const externalStatusKey = getClaimStatusLabelKey();
    const statusDisplayOnPortalKey = getStatusDisplayOnPortalKey();
    const allStatuses = [];
    if (statusesListRaw?.length > 0) {
      statusesListRaw.forEach((s, i) => {
        if (s[statusDisplayOnPortalKey]) {
          obj[s[externalStatusKey]] = obj[s[externalStatusKey]]
            ? [...obj[s[externalStatusKey]], s.InternalStatus]
            : [s.InternalStatus];
          allStatuses.push(s.InternalStatus);
        }
        if (i === statusesListRaw.length - 1) {
          setFomattedStatusesObject({ ...obj, all: allStatuses });
        }
      });
    }
  }, [statusesListRaw]);

  useEffect(() => {
    const getStatusesList = async () => {
      return await axiosInstance.get(`${APIEndpoints.getAllClaimLabelsLIst()}`);
    };

    (async () => {
      try {
        const resourceData = await getStatusesList();
        const externalStatusKey = getClaimStatusLabelKey();
        const resourceList = resourceData?.data?.Response?.ClaimStatusLabels;
        if (resourceList?.length > 0) {
          const activeItems = [{ label: 'All', value: 'all' }];
          const displayOnPortalKey = getStatusDisplayOnPortalKey();
          resourceList.map((element, index) => {
            if (
              element[displayOnPortalKey] &&
              !activeItems.includes(element[externalStatusKey])
            ) {
              activeItems.push(element[externalStatusKey]);
            }
            if (index === resourceList.length - 1) {
              //setStatusesList(activeItems);
              setValuesList({
                ...valuesList,
                'claim-status': activeItems.map((v, i) => {
                  return i === 0 ? v : { label: v, value: v };
                }),
              });
            }
          });
        }
        setStatusesListRaw(resourceList);
        //setOldRowsData( [ ...resourceList ] );
      } catch (error) {
        console.error(error);
      } finally {
        //setLoader( false );
      }
    })();
  }, []);

  //get claim external status key
  const getClaimStatusLabelKey = () => {
    //loggedInUserType
    return `ExternalStatus${loggedInUserType}`;
  };

  //get claim external status key
  const getStatusDisplayOnPortalKey = () => {
    //loggedInUserType
    return `DisplayOnPortal${loggedInUserType}`;
  };

  //calculate from date according to selected date range
  const calculateDate = (unit) => {
    switch (unit) {
      case 'today':
        return moment().format('YYYY-MM-DD');
      case 'last-1-week':
        return moment().subtract(7, 'days').format('YYYY-MM-DD');
      case 'last-1-month':
        return moment().subtract(1, 'month').format('YYYY-MM-DD');
      case 'last-3-months':
        return moment().subtract(3, 'months').format('YYYY-MM-DD');
      case 'last-6-months':
        return moment().subtract(6, 'months').format('YYYY-MM-DD');
      case 'last-one-year':
        return moment().subtract(12, 'months').format('YYYY-MM-DD');
      //return moment().startOf('year').format('YYYY-MM-DD');
      default:
        return moment().format('YYYY-MM-DD');
    }
  };

  const { t } = props;

  //add criteria on click of criteria menu item
  const handleAddCriteria = (value) => {
    setSelectedCriteriaList([...selectedCriteriaList, value]);
    if (
      value.value === 'member-information' ||
      value.value === 'provider-information' ||
      value.value === 'claim-date'
    ) {
      setUserEnteredCriteriaValues({
        ...userEnteredCriteriaValues,
        [value.value]: [{ ...criteriaDefaultValues[value.value] }],
      });
    } else {
      setUserEnteredCriteriaValues({
        ...userEnteredCriteriaValues,
        [value.value]: criteriaDefaultValues[value.value],
      });
    }
  };

  const [providerListDataLocal, setProviderListDataLocal] = useState([]);
  const [selectedProviderDataLocal, setSelectedProviderDataLocal] = useState(
    [],
  );
  const [memberListDataLocal, setMemberListDataLocal] = useState([]);
  const [selectedMemberDataLocal, setSelectedMemberDataLocal] = useState([]);

  const [disableProviderSearchBtn, setDisableProviderSearchBtn] =
    useState(false);

  const [totalDateInputsSelected, setTotalDateInputsSelected] = useState(1);

  const [openProviderModal, setOpenProviderModal] = useState(false);
  const [openMemberModal, setOpenMemberModal] = useState(false);

  function makeDataClearMember() {
    setSelectedMemberDataLocal([]);
    setMemberListDataLocal([]);
    setIsServerError(false);
    setUserEnteredCriteriaValues({
      ...userEnteredCriteriaValues,
      //'member-information': [criteriaDefaultValues['member-information']],
      'member-information': [
        {
          first_name: null,
          last_name: null,
          dob: null,
          member_id: null,
          patient_control_number: null,
        },
      ],
    });
  }

  function makeDataClearProvider() {
    setSelectedProviderDataLocal([]);
    setProviderListDataLocal([]);
    setIsServerError(false);
    setUserEnteredCriteriaValues({
      ...userEnteredCriteriaValues,
      'provider-information': [criteriaDefaultValues['provider-information']],
    });
  }

  //delete already selected criteria
  const handleDeleteCriteria = (value) => {
    setSelectedCriteriaList(
      [...selectedCriteriaList].filter((val) => val.value !== value),
    );
    const alreadySelectedUserEnteredCriteriaValues = {
      ...userEnteredCriteriaValues,
    };
    delete alreadySelectedUserEnteredCriteriaValues[value];
    setUserEnteredCriteriaValues({
      ...alreadySelectedUserEnteredCriteriaValues,
    });
    if (value === 'claim-date') {
      setSelectedDateTypeValues([]);
      setTotalDateInputsSelected(1);
    }
    if (value === 'provider-information') {
      setProviderDetailsToSearch({});
    }
  };

  //handle provider type change
  const handleProviderValueChange = async (fieldName, val, index) => {
    //['name','npi', 'tax-id', 'specialty']
    setUserEnteredCriteriaValues({
      ...userEnteredCriteriaValues,

      'provider-information': [
        ...userEnteredCriteriaValues['provider-information'],
      ].map((value, i) => {
        if (i === index) {
          if (fieldName === 'type') {
            return {
              [fieldName]: val,
              search_by: searchByProviderOptions[val.value][0],
              name: null,
              'tax-id': null,
              npi: null,
            };
          } else {
            if (fieldName === 'search_by') {
              if (val.value === 'name-tax-id') {
                return { ...value, [fieldName]: val, npi: '', specialty: '' };
              } else if (val.value === 'name-npi') {
                return {
                  ...value,
                  [fieldName]: val,
                  'tax-id': '',
                  specialty: '',
                };
              } else if (val.value === 'tax-id') {
                return {
                  ...value,
                  [fieldName]: val,
                  name: '',
                  npi: '',
                  spcialty: '',
                };
              } else if (val.value === 'specialty') {
                return {
                  ...value,
                  [fieldName]: val,
                  name: '',
                  npi: '',
                  'tax-id': '',
                };
              } else {
                return {
                  ...value,
                  [fieldName]: val,
                  name: '',
                  npi: '',
                  'tax-id': '',
                };
              }
            } else {
              return { ...value, [fieldName]: val };
            }
          }
        } else {
          return value;
        }
      }),
    });
    if (
      ['name', 'facility_name', 'npi', 'tax_id', 'specialty'].includes(
        fieldName,
      )
    ) {
      setProviderDetailsToSearch('');
    }
  };

  const handleDisableSearchBtn = () => {
    let btnValue = false;
    //disable button code
    //provider-info
    for (let i = 0; i < providerPermissionsListArray.length; i++) {
      //if (userEnteredCriteriaValues['provider-information']) {
      //if (
      //userEnteredCriteriaValues['provider-information'][0][
      //providerPermissionsListArray[i]
      //] === null ||
      //userEnteredCriteriaValues['provider-information'][0][
      //providerPermissionsListArray[i]
      //] === ''
      //)
      if (!selectedProviderDataLocal?.length) {
        setisSearchBtnDisable(true);
        btnValue = true;
        break;
      } else {
        setisSearchBtnDisable(false);
      }
    }

    //member-info
    if (btnValue === false) {
      for (let j = 0; j < memberPermissionsListArray.length; j++) {
        //if (userEnteredCriteriaValues['member-information']) {
        //if (
        //userEnteredCriteriaValues['member-information'][0][
        //memberPermissionsListArray[j]
        //] === null ||
        //userEnteredCriteriaValues['member-information'][0][
        //memberPermissionsListArray[j]
        //] === ''
        //)
        if (!selectedMemberDataLocal?.length) {
          setisSearchBtnDisable(true);
          btnValue = true;
          break;
        } else {
          setisSearchBtnDisable(false);
        }
      }
    }

    //sccf
    if (btnValue === false) {
      for (let k = 0; k < sccfPermissionsListArray.length; k++) {
        if (userEnteredCriteriaValues.sccf !== undefined) {
          if (
            userEnteredCriteriaValues.sccf === null ||
            userEnteredCriteriaValues.sccf === ''
          ) {
            setisSearchBtnDisable(true);
            btnValue = true;
            break;
          } else {
            setisSearchBtnDisable(false);
          }
        }
      }
    }

    //claim number
    if (btnValue === false) {
      for (let k = 0; k < claimnoPermissionsListArray.length; k++) {
        if (userEnteredCriteriaValues['claim-number'] !== undefined) {
          if (
            userEnteredCriteriaValues['claim-number'] === null ||
            userEnteredCriteriaValues['claim-number'] === ''
          ) {
            setisSearchBtnDisable(true);
            btnValue = true;
            break;
          } else {
            setisSearchBtnDisable(false);
          }
        }
      }
    }
  };

  const validateMinSearchCriteria = () => {
    if (
      (selectedMemberDataLocal?.length ||
        selectedProviderDataLocal?.length ||
        userEnteredCriteriaValues['claim-number'] ||
        userEnteredCriteriaValues['sccf']) &&
      !providerPermissionsListArray?.length &&
      !memberPermissionsListArray?.length &&
      !sccfPermissionsListArray?.length &&
      !claimnoPermissionsListArray?.length
    ) {
      setisSearchBtnDisable(false);
    } else {
      if (
        !providerPermissionsListArray?.length &&
        !memberPermissionsListArray?.length &&
        !sccfPermissionsListArray?.length &&
        !claimnoPermissionsListArray?.length
      ) {
        if (!isSearchBtnDisable) {
          setisSearchBtnDisable(true);
        }
      } else {
        handleDisableSearchBtn();
      }
    }
  };

  const handleDisableMemberSearchBtn = () => {
    if (memberPermissionsListArray.length) {
      let permissionsSatisfied = false;
      for (let j = 0; j < memberPermissionsListArray.length; j++) {
        if (userEnteredCriteriaValues['member-information']) {
          if (
            userEnteredCriteriaValues['member-information'][0][
              memberPermissionsListArray[j]
            ] === null ||
            userEnteredCriteriaValues['member-information'][0][
              memberPermissionsListArray[j]
            ] === ''
          ) {
            setIsMemberSearchBtnDisable(true);
            break;
          } else {
            //setIsMemberSearchBtnDisable(false);
            permissionsSatisfied = true;
          }
        }

        if (
          j === memberPermissionsListArray.length - 1 &&
          permissionsSatisfied === true
        ) {
          if (
            userEnteredCriteriaValues['member-information'][0]['member_id'] ||
            userEnteredCriteriaValues['member-information'][0]['last_name']
          ) {
            setIsMemberSearchBtnDisable(false);
          } else {
            setIsMemberSearchBtnDisable(true);
          }
        }
      }
    } else {
      if (
        !memberPermissionsListArray.length ||
        (!memberPermissionsListArray?.includes('member_id') &&
          !memberPermissionsListArray?.includes('last_name'))
      ) {
        if (userEnteredCriteriaValues['member-information']) {
          const params = userEnteredCriteriaValues['member-information'][0];
          if (
            (params.last_name !== null && params.last_name !== '') ||
            (params.member_id !== null && params.member_id !== '')
          ) {
            setIsMemberSearchBtnDisable(false);
          } else {
            setIsMemberSearchBtnDisable(true);
          }
        }
      }
    }
  };

  const handleDisableProviderSearchBtn = () => {
    if (providerPermissionsListArray.length) {
      let permissionsSatisfied = false;
      for (let i = 0; i < providerPermissionsListArray.length; i++) {
        if (userEnteredCriteriaValues['provider-information']) {
          if (
            userEnteredCriteriaValues['provider-information'][0][
              providerPermissionsListArray[i]
            ] === null ||
            userEnteredCriteriaValues['provider-information'][0][
              providerPermissionsListArray[i]
            ] === ''
          ) {
            setDisableProviderSearchBtn(true);
            break;
          } else {
            //setDisableProviderSearchBtn(false);
            permissionsSatisfied = true;
          }
        }
        if (
          i === providerPermissionsListArray.length - 1 &&
          permissionsSatisfied === true
        ) {
          if (
            userEnteredCriteriaValues['provider-information'][0]['specialty'] ||
            userEnteredCriteriaValues['provider-information'][0]['name'] ||
            userEnteredCriteriaValues['provider-information'][0]['npi'] ||
            userEnteredCriteriaValues['provider-information'][0]['tax_id']
          ) {
            setDisableProviderSearchBtn(false);
          } else {
            setDisableProviderSearchBtn(true);
          }
        }
      }
    } else {
      if (
        !providerPermissionsListArray.length ||
        (!providerPermissionsListArray?.includes('name') &&
          !providerPermissionsListArray?.includes('specialty'))
      ) {
        if (userEnteredCriteriaValues['provider-information']) {
          const params = userEnteredCriteriaValues['provider-information'][0];
          if (
            //(params.facility_name !== null && params.facility_name !== '') ||
            (params.name !== null && params.name !== '') ||
            (params.specialty !== null && params.specialty !== '') ||
            (params.npi !== null && params.npi !== '') ||
            (params.tax_id !== null && params.tax_id !== '')
          ) {
            setDisableProviderSearchBtn(false);
          } else {
            setDisableProviderSearchBtn(true);
          }
        }
      }
    }
  };

  const memberSearchAPI = async () => {
    setDataFetching(true);
    setIsServerError(false);
    let filterParams = '';
    if (userEnteredCriteriaValues['member-information']?.length > 0) {
      const params = userEnteredCriteriaValues['member-information'][0];
      if (params?.first_name) {
        filterParams += `/firstname/${params?.first_name}`;
      }
      if (params?.last_name) {
        filterParams += `/lastname/${params?.last_name}`;
      }
      if (params?.member_id) {
        //filterParams += `/npi/${params?.member_id}`;

        filterParams += `/certificatenumber/${params.member_id}`;

        filterParams += `/ssn/${params.member_id}`;

        filterParams += `/alternateid1/${params.member_id}`;

        filterParams += `/alternateid2/${params.member_id}`;
      }
      if (params?.dob) {
        filterParams += `/dateofbirth/${params?.dob}`;
      }

      if (bob !== 'all' && !filterParams.includes('/blkofbusoid/'))
        filterParams += `/blkofbusoid/${bob}`;
      if (employer !== 'all' && !filterParams.includes('/clientoid/'))
        filterParams += `/clientoid/${employer}`;
      if (locations !== 'all' && !filterParams.includes('/locationoid/'))
        filterParams += `/locationoid/${locations}`;

      try {
        const results = await axiosInstance.get(
          `${APIEndpoints.searchMembers()}${filterParams}/pagesize/200/`,
        );
        const memberInfoList = results?.data?.Response?.MemberOrDependentSearch;

        setMemberListDataLocal(memberInfoList);
        setDataFetching(false);
        if (!memberInfoList.length) setIsServerError(true);
      } catch (error) {
        setDataFetching(false);
        setIsServerError(true);
        if (error?.response?.status === 404) {
          toast.error(
            <ToastMessage
              type="error"
              title="Error!"
              subTitle="No results found!
              We could not find any Member/Dependent with the values that you have entered. Try again using other values. "
            />,
          );
        } else {
          toast.error(
            <ToastMessage
              type="error"
              title="Error!"
              subTitle="Something went wrong!
              Failed to retrieve data.
              Try again later."
            />,
          );
        }
      }
    }
  };

  const providerSearchAPI = async () => {
    setDataFetching(true);
    setIsServerError(false);
    let filterParams = '';
    if (userEnteredCriteriaValues['provider-information']?.length > 0) {
      const params = userEnteredCriteriaValues['provider-information'][0];
      if (params?.name) {
        filterParams += `/doctorname/${params?.name}`;
      }
      if (params?.facility_name) {
        filterParams += `/facilityname/${params?.facility_name}`;
      }
      if (params?.npi) {
        filterParams += `/npi/${params?.npi}`;
      }
      if (params?.city) {
        filterParams += `/city/${params?.city}`;
      }
      if (params?.county) {
        filterParams += `/county/${params?.county}`;
      }
      if (params?.tax_id) {
        filterParams += `/taxid/${params?.tax_id}`;
      }
      if (params?.state) {
        filterParams += `/state/${params?.state}`;
      }
      if (params?.specialty?.value) {
        filterParams += `/speciality/${params?.specialty?.value}`;
      }
      if (params?.zip_code) {
        filterParams += `/postalcode/${params?.zip_code}`;
      }
    }
    try {
      const results = await axiosInstance.get(
        `${APIEndpoints.searchPhysicians()}${filterParams}/pagesize/200/providersearchflag/true`,
      );
      const providerList = results?.data?.Response?.PhysicianViewDetails;

      setProviderListDataLocal(providerList);
      setDataFetching(false);
      if (!providerList.length) setIsServerError(true);
    } catch (error) {
      setDataFetching(false);
      setIsServerError(true);
      if (error?.response?.status === 404) {
        toast.error(
          <ToastMessage
            type="error"
            title="Error!"
            subTitle="No results found!
            We could not find any Provider with the values that you have entered. Try again using other values. "
          />,
        );
      } else {
        toast.error(
          <ToastMessage
            type="error"
            title="Error!"
            subTitle="Something went wrong!
            Failed to retrieve data.
            Try again later."
          />,
        );
      }
    }
  };

  //api call to fetch providers list accoring to parameters provided
  const searchProvidersList = async (params) => {
    //params is an object for all inputs
    const providerType = params.type.value;
    let urlParams = '';

    if (params['tax_id']) {
      urlParams += urlParams === '' ? '' : '/';
      urlParams += `taxid/${params['tax_id']}`;
    }
    if (params.npi) {
      urlParams += urlParams === '' ? '' : '/';
      urlParams += `npi/${params.npi}`;
    }
    if (params.specialty) {
      urlParams += urlParams === '' ? '' : '/';
      urlParams += `speciality/${params.specialty?.value}`;
    }
    if (providerType === 'facility') {
      if (params['facility_name']) {
        urlParams += `/facilityname/${params['facility_name']}`;
      }
      if (urlParams) {
        try {
          const results = await axiosInstance.get(
            `${APIEndpoints.searchFacilities()}${urlParams}/pagesize/200/`,
          );
          if (results.data.Response.FacilityDetails?.length == 0) {
            //toast.dismiss();
            //toast.error(
            //<ToastMessage
            //type="error"
            //title="Error!"
            //subTitle="We could not find any provider from your input(s). Try changing your inputs."
            ///>,
            //);
            return null;
          } else {
            const commaSeparatedList =
              results.data.Response.FacilityDetails.map(
                (data) => data.FacilityOID,
              ).join(',');
            setProviderDetailsToSearch({
              type: 'facility',
              ids: commaSeparatedList,
            });
            return commaSeparatedList;
          }
        } catch (error) {
          return null;
        }
      } else {
        return null;
      }
    }

    if (providerType === 'doctor') {
      if (params.name) {
        urlParams += `/doctorname/${params.name}`;
      }
      if (urlParams) {
        try {
          const results = await axiosInstance.get(
            `${APIEndpoints.searchPhysicians()}${urlParams}/pagesize/200/`,
          );
          if (results.data.Response.PhysicianViewDetails?.length === 0) {
            return null;
          } else {
            const commaSeparatedList =
              results.data.Response.PhysicianViewDetails.map(
                (data) => data.ConnectorID,
              ).join(',');
            setProviderDetailsToSearch({
              type: 'doctor',
              ids: commaSeparatedList,
            });
            return commaSeparatedList;
          }
        } catch (error) {
          return null;
        }
      } else {
        return null;
      }
    }
    //searchFacilities
  };

  useEffect(() => {
    console.log(
      '********** 1087 userEnteredCriteriaValues',
      userEnteredCriteriaValues,
    );
  }, [userEnteredCriteriaValues]);

  //handle claim date value changes
  const handleClaimDateValueChange = (
    fieldName,
    val,
    index,
    isDefaultValue,
  ) => {
    console.log(
      '********** handleClaimDateValueChange',
      fieldName,
      val,
      index,
      isDefaultValue,
      userEnteredCriteriaValues['claim-date'],
    );
    setUserEnteredCriteriaValues({
      ...userEnteredCriteriaValues,
      'claim-date': [...userEnteredCriteriaValues['claim-date']].map(
        (value, i) => {
          if (i === index) {
            if (fieldName === 'type') {
              const alreadySelectedOption =
                userEnteredCriteriaValues['claim-date'][index].type?.value;
              setSelectedDateTypeValues(
                [...selectedDateTypeValues, val.value].filter(
                  (v) => v !== alreadySelectedOption,
                ),
              );
            }

            if (fieldName === 'date_range') {
              return {
                ...value,
                date_from: calculateDate(val.value),
                date_to: calculateDate('today'),
                [fieldName]: val,
                from_date: null,
                to_date: null,
              };
            } else if (['date_from', 'date_to'].includes(fieldName)) {
              if ('date_from' === fieldName) {
                return {
                  ...value,
                  [fieldName]: moment(val).format('YYYY-MM-DD'),
                  date_to: null,
                  to_date: null,
                };
              } else {
                return {
                  ...value,
                  [fieldName]: moment(val).format('YYYY-MM-DD'),
                };
              }
            } else if (fieldName === 'type') {
              return {
                ...value,
                [fieldName]: val,
                date_range: { label: 'Last 1 week', value: 'last-1-week' },
                from_date: null,
                to_date: null,
                date_from: calculateDate('last-1-week'),
                date_to: calculateDate('today'),
              };
            } else {
              if (fieldName === 'from_date') {
                return {
                  ...value,
                  [fieldName]: val,
                  date_from: moment(val).format('YYYY-MM-DD'),
                  to_date: null,
                  date_to: null,
                };
              } else {
                if (fieldName === 'to_date') {
                  return {
                    ...value,
                    [fieldName]: val,
                    date_to: moment(val).format('YYYY-MM-DD'),
                  };
                } else {
                  return { ...value, [fieldName]: val };
                }
              }
            }
          } else {
            return value;
          }
        },
      ),
    });
  };

  const handleAddMoreClaimDate = () => {
    setTotalDateInputsSelected(
      (totalDateInputsSelected) => totalDateInputsSelected + 1,
    );
    const alreadySelectedTypeValues = [
      ...userEnteredCriteriaValues['claim-date'],
    ].map((d) => d?.type?.value);

    const remainingTypeValuesToSelect = claimDateSearchByOptions.filter(
      (d) => !alreadySelectedTypeValues.includes(d?.value),
    );

    if (remainingTypeValuesToSelect.length > 0) {
      setUserEnteredCriteriaValues({
        ...userEnteredCriteriaValues,
        'claim-date': [
          ...userEnteredCriteriaValues['claim-date'],
          { ...criteriaDefaultValues['claim-date'] },
        ],
      });
    }
  };

  //handleUserInputForSearchCriteria
  /**
   *@method: handleUserInputForSearchCriteria
   *@param: fieldName | string - field name
   *@param: value | string - field value
   *@param: isChecked | if the input is checkbox
   *@param: index | if there are mutiple data inputs
   */
  const handleUserInputForSearchCriteria = (
    criteriaName,
    fieldName,
    value,
    isChecked,
    index,
  ) => {
    switch (criteriaName) {
      case 'claim-number':
        setUserEnteredCriteriaValues({
          ...userEnteredCriteriaValues,
          'claim-number': value,
        });
        break;
      case 'claim-status':
        if (isChecked) {
          setUserEnteredCriteriaValues({
            ...userEnteredCriteriaValues,
            [criteriaName]: [...userEnteredCriteriaValues[criteriaName], value],
          });
        }
        if (!isChecked) {
          setUserEnteredCriteriaValues({
            ...userEnteredCriteriaValues,
            [criteriaName]: [...userEnteredCriteriaValues[criteriaName]].filter(
              (val) => val.value !== value.value,
            ),
          });
        }
        break;
      case 'products':
        if (isChecked) {
          setUserEnteredCriteriaValues({
            ...userEnteredCriteriaValues,
            [criteriaName]: [...userEnteredCriteriaValues[criteriaName], value],
          });
        }
        if (!isChecked) {
          setUserEnteredCriteriaValues({
            ...userEnteredCriteriaValues,
            [criteriaName]: [...userEnteredCriteriaValues[criteriaName]].filter(
              (val) => val.value !== value.value,
            ),
          });
        }
        break;
      case 'sccf':
        setUserEnteredCriteriaValues({
          ...userEnteredCriteriaValues,
          [criteriaName]: value,
        });
        break;
      case 'member-information':
        //eslint-disable-next-line no-case-declarations
        const alreadyEnteredDataArray = [
          ...userEnteredCriteriaValues[criteriaName],
        ];
        if (fieldName === 'dob') {
          if (value) {
            if (value.toString().length < 20) {
              alreadyEnteredDataArray[index][fieldName] = null;
            } else {
              alreadyEnteredDataArray[index][fieldName] =
                moment(value).format('YYYY-MM-DD');
            }
          }
        } else {
          alreadyEnteredDataArray[index][fieldName] = value;
        }

        setUserEnteredCriteriaValues({
          ...userEnteredCriteriaValues,
          [criteriaName]: alreadyEnteredDataArray,
        });
        break;
      case 'provider-information':
        //eslint-disable-next-line no-case-declarations
        const alreadyEnteredProviderDataArray = [
          ...userEnteredCriteriaValues[criteriaName],
        ];
        alreadyEnteredProviderDataArray[index][fieldName] = value;
        setUserEnteredCriteriaValues({
          ...userEnteredCriteriaValues,
          [criteriaName]: alreadyEnteredProviderDataArray,
        });
        break;
      case 'claim-date':
        //eslint-disable-next-line no-case-declarations
        const alreadyEnteredClaimDates = [
          ...userEnteredCriteriaValues[criteriaName],
        ];
        alreadyEnteredClaimDates[index][fieldName] = value;
        setUserEnteredCriteriaValues({
          ...userEnteredCriteriaValues,
          [criteriaName]: alreadyEnteredClaimDates,
        });
        break;
      default:
        break;
    }
  };

  //fetch member information from user inputs
  const fetchMemberInformation = async (memberData) => {
    let url = '';
    if (memberData.first_name) {
      url += `/firstname/${memberData.first_name}`;
    }
    if (memberData.last_name) {
      url += `/lastname/${memberData.last_name}`;
    }
    if (memberData.member_id) {
      //changing the params as per the permissions
      //once new permissions approved need to change the permission names according to the new
      url += `${url !== '' ? '/' : ''}/certificatenumber/${
        memberData.member_id
      }`;
      url += `${url !== '' ? '/' : ''}/ssn/${memberData.member_id}`;
      url += `${url !== '' ? '/' : ''}/alternateid1/${memberData.member_id}`;
      url += `${url !== '' ? '/' : ''}/alternateid2/${memberData.member_id}`;
    }
    if (memberData.dob) {
      url += `${url !== '' ? '/' : ''}/dateofbirth/${memberData.dob}`;
    }
    try {
      if (url) {
        const membersSearched = await axiosInstance.get(
          `${APIEndpoints.searchMembers() + url}`.replace(/([^:]\/)\/+/g, '$1'),
        );
        const commaSeparatedList = ['Member', 'Dependent'].includes(
          userEnteredCriteriaValues['member-type'],
        )
          ? membersSearched.data.Response.MemberOrDependentSearch.filter(
              (v) => v.MemberType === userEnteredCriteriaValues['member-type'],
            )
              .map((data) => data.OID)
              .slice(0, 200)
              .join(',')
          : membersSearched.data.Response.MemberOrDependentSearch.map(
              (data) => data.OID,
            )
              .slice(0, 200)
              .join(',');
        if (!commaSeparatedList) {
          toast.error(
            <ToastMessage
              type="error"
              title="Error!"
              subTitle="We could not find any member from your inputs. Try other values to search by member"
            />,
          );
        } else {
          setMemberIdsToSearch({
            type: userEnteredCriteriaValues['member-type'],
            ids: commaSeparatedList,
          });
        }

        return commaSeparatedList;
      } else {
        return 'nothing_searched';
      }
    } catch (error) {
      if (error?.response?.status === 404) {
        toast.error(
          <ToastMessage
            type="error"
            title="Error!"
            subTitle="We could not find any member from your inputs. Try other values to search by member"
          />,
        );
      } else {
        toast.error(
          <ToastMessage
            type="error"
            title="Error!"
            subTitle="Some error occured searching for members."
          />,
        );
      }
      return false;
    }
  };

  const actionMenuRef = createRef(null);

  //function to check date values object and show toast
  const validateSelectedDateValue = (data) => {
    if (data?.date_range?.value === 'custom-date') {
      if (!data.to_date || !data.from_date) {
        const fieldLabel = !data.from_date ? 'From Date' : 'To Date';
        toast.error(
          <ToastMessage
            type="error"
            title="Error!"
            subTitle={`Enter valid ${fieldLabel} for ${data['type']['label']}`}
          />,
        );
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  };

  //api call for search claims
  const searchClaims = async (e) => {
    e.preventDefault();
    const errorsOccurred = [];
    let shouldSearchClaims = false;
    const providersList = null;
    let membersList = null;
    //let providersList_doctor = null;
    //const providersList_facility = null;

    //fetch providers from user inputs
    //if (userEnteredCriteriaValues['provider-information']) {
    //userEnteredCriteriaValues['provider-information'][0].type = {
    //value: 'doctor',
    //};
    //providersList_doctor = await searchProvidersList(
    //userEnteredCriteriaValues['provider-information'][0],
    //);

    ///*userEnteredCriteriaValues['provider-information'][0].type = {
    //value: 'facility',
    //};
    //providersList_facility = await searchProvidersList(
    //userEnteredCriteriaValues['provider-information'][0],
    //); */

    //if (providersList_doctor || providersList_facility) {
    //shouldSearchClaims = true;
    //} else {
    //toast.dismiss();
    //toast.error(
    //<ToastMessage
    //type="error"
    //title="Error!"
    //subTitle="We could not find any provider from your input(s). Try changing your inputs."
    ///>,
    //);
    //}
    //} else {
    //shouldSearchClaims = true;
    //}

    //fetch members from user inputs
    if (userEnteredCriteriaValues['member-information']) {
      shouldSearchClaims = false;
      membersList = await fetchMemberInformation(
        userEnteredCriteriaValues['member-information'][0],
      );
      if (membersList) {
        shouldSearchClaims = true;
      }
    } else {
      if (providersList || providersList === null) {
        shouldSearchClaims = true;
      }
    }

    if (shouldSearchClaims === true) {
      try {
        if (Object.keys(userEnteredCriteriaValues).length > 0) {
          let valuesToSubmit = '';
          Object.keys(userEnteredCriteriaValues).forEach((key, index) => {
            if (userEnteredCriteriaValues[key]) {
              if (key === 'claim-number') {
                valuesToSubmit += `/Claimnumber/${userEnteredCriteriaValues[key]}`;
              } else if (key === 'claim-status') {
                if (userEnteredCriteriaValues[key]?.length > 0) {
                  if (
                    userEnteredCriteriaValues[key].findIndex(
                      (v) => v.value === 'all',
                    ) > -1
                  ) {
                    valuesToSubmit += `/claimstatus/${fomattedStatusesObject.all.join(
                      ',',
                    )}`;
                  } else {
                    valuesToSubmit += `/claimstatus/${userEnteredCriteriaValues[
                      key
                    ]
                      .map((v) => fomattedStatusesObject[v.value].join(','))
                      .join(',')}`;
                  }
                }
              } else if (key === 'products') {
                if (userEnteredCriteriaValues[key]?.length > 0) {
                  valuesToSubmit += `/Product/${[
                    ...userEnteredCriteriaValues[key].map((v) => v.value),
                    //...userEnteredCriteriaValues[key],
                  ].join(',')}`;
                }
              } else if (key === 'sccf') {
                if (userEnteredCriteriaValues[key]?.length > 0) {
                  valuesToSubmit += `/sccf/${userEnteredCriteriaValues[key]}`;
                }
              } else if (key === 'member-information') {
                //#write a function to get all searched members oid
                //if (memberIdsToSearch.ids) {
                //valuesToSubmit += `/memberoid/${memberIdsToSearch.ids}`;
                if (selectedMemberDataLocal[0]) {
                  if (selectedMemberDataLocal[0].MemberType === 'Dependent') {
                    valuesToSubmit += `/dependentoid/${selectedMemberDataLocal[0].OID}`;
                  } else if (
                    selectedMemberDataLocal[0].MemberType === 'Member'
                  ) {
                    valuesToSubmit += `/memberoid/${selectedMemberDataLocal[0].OID}`;
                  } else {
                    valuesToSubmit += `/dependentoid/${selectedMemberDataLocal[0].OID}`;
                    valuesToSubmit += `/memberoid/${selectedMemberDataLocal[0].OID}`;
                  }
                }
                //}
                //patientcontrolnumber
                if (
                  userEnteredCriteriaValues[key][0]['patient_control_number']
                ) {
                  valuesToSubmit += `/patientcontrolnumber/${userEnteredCriteriaValues[key][0]['patient_control_number']}`;
                }
              } else if (key === 'provider-information') {
                //only 0 index to process here, change when multiple providers are there to search
                //for facility :- facilityoid
                //for doctor :- connectorid
                if (selectedProviderDataLocal[0]) {
                  if (selectedProviderDataLocal[0].isdummy) {
                    //facilityoid
                    valuesToSubmit += `/facilityoid/${selectedProviderDataLocal[0].FacilityOid}`;
                  } else {
                    valuesToSubmit += `/connectorid/${selectedProviderDataLocal[0].ConnectorID}`;
                  }
                }
              } else if (key === 'claim-date') {
                if (userEnteredCriteriaValues[key]?.length > 0) {
                  userEnteredCriteriaValues[key].forEach((d) => {
                    if (d.type && d.type?.value) {
                      if (d.type.value === 'processed-date') {
                        if (validateSelectedDateValue(d)) {
                          if (d.date_from && d.date_to) {
                            valuesToSubmit += `/processdatefrom/${d.date_from}/processdateto/${d.date_to}`;
                          }
                        } else {
                          errorsOccurred.push(d.type.value);
                          return false;
                        }
                      } else if (d.type.value === 'paid-date') {
                        if (validateSelectedDateValue(d)) {
                          if (d.date_from && d.date_to)
                            valuesToSubmit += `/PaymentDateFrom/${d.date_from}/PaymentDateTo/${d.date_to}`;
                        } else {
                          errorsOccurred.push(d.type.value);
                          return false;
                        }
                      } else if (d.type.value === 'service-date') {
                        if (validateSelectedDateValue(d)) {
                          if (d.date_from && d.date_to)
                            valuesToSubmit += `/ServiceDateFrom/${d.date_from}/ServiceDateTo/${d.date_to}`;
                        } else {
                          errorsOccurred.push(d.type.value);
                          return false;
                        }
                      } else if (d.type.value === 'received-date') {
                        if (validateSelectedDateValue(d)) {
                          if (d.date_from && d.date_to)
                            valuesToSubmit += `/ReceivedDateFrom/${d.date_from}/ReceivedDateTo/${d.date_to}`;
                        } else {
                          errorsOccurred.push(d.type.value);
                          return false;
                        }
                      }
                    } else {
                      return true;
                    }
                  });
                }
              }
            }
            if (bob !== 'all' && !valuesToSubmit.includes('/BlkOfBusID/'))
              valuesToSubmit += `/BlkOfBusID/${bob}`;
            if (employer !== 'all' && !valuesToSubmit.includes('/ClientID/'))
              valuesToSubmit += `/ClientID/${employer}`;
            if (
              locations !== 'all' &&
              !valuesToSubmit.includes('/LocationName/')
            )
              valuesToSubmit += `/LocationName/${locations}`;
            if (index === Object.keys(userEnteredCriteriaValues).length - 1) {
              if (errorsOccurred.length === 0) {
                if (valuesToSubmit !== '') {
                  navigate('/admin/search-claims-results', {
                    state: {
                      paramsUrl: valuesToSubmit,
                      searchCriteria: userEnteredCriteriaValues,
                      selectedCriteriaList: selectedCriteriaList,
                      selectedDateTypeValues: selectedDateTypeValues,
                      providerSelectedValue: selectedProviderDataLocal,
                      memberSelectedValue: selectedMemberDataLocal,
                      isComingFromSearchResult: true,
                    },
                  });
                }
                //else {
                //toast.error(
                //<ToastMessage
                //type="error"
                //title="Error!"
                //subTitle="Input atleast one criteria to search claims."
                ///>,
                //);
                //}
              } else {
                return false;
              }
            }
          });
        } else {
          toast.error(
            <ToastMessage
              type="error"
              title="Error!"
              subTitle="Input atleast one criteria to search claims."
            />,
          );
        }
      } catch (error) {
        console.log('error >>>>>>>>> ', error);
      }
    }
  };

  const handleDeleteDate = (index) => {
    const selectedDates = [...userEnteredCriteriaValues['claim-date']];
    const alreadySelectedOption = selectedDates[index].type?.value;
    const filteredDates = selectedDates.filter((v, i) => i !== index);

    setSelectedDateTypeValues(
      [...selectedDateTypeValues].filter((v) => v !== alreadySelectedOption),
    );

    setTotalDateInputsSelected(filteredDates.length);
    if (filteredDates.length === 0) {
      handleDeleteCriteria('claim-date');
    }
    setUserEnteredCriteriaValues({
      ...userEnteredCriteriaValues,
      'claim-date': filteredDates,
    });
  };

  const handleProviderButton = () => {
    setOpenProviderModal(true);
    setSelectedProviderDataLocal([]);
  };

  const handleMemberButton = () => {
    setOpenMemberModal(true);
    handleDisableSearchBtn();
  };

  //For Provider search
  const permissionForProviderSearch = MasterPermissions.CheckPermission(
    'Provider Information',
  );

  const permissionForMemberSearch =
    MasterPermissions.CheckPermission('Member Information');

  const handleMinSearchCriteriaBtnClick = (criteriaValue) => {
    const alreadySlectedCriteria = [...selectedCriteriaList].filter(
      (val) => val.value === criteriaValue,
    );

    if (alreadySlectedCriteria?.length === 0) {
      const menuItemFromList = [...criteriaMenuItems].filter(
        (val) => val.value === criteriaValue,
      );
      if (menuItemFromList?.length) {
        handleAddCriteria(menuItemFromList[0]);
        if (criteriaValue === 'member-information') {
          setTimeout(() => {
            searchMemberBtnRef?.current?.click();
          }, 0);
        }
        if (criteriaValue === 'provider-information') {
          setTimeout(() => {
            searchProviderBtnRef?.current?.click();
          }, 0);
        }
      }
    }
  };

  //to check if permissions include minimum search criteria
  useEffect(() => {
    const checkTimeout = setTimeout(() => {
      const providerPermissions = ProviderPermissionsList(isSuperUser);
      const memberPermissions = MemberPermissionsList(isSuperUser);
      const sccfPermissions = sccfPermissionsList(isSuperUser);
      const claimNo = claimnoPermissionsList(isSuperUser);
      if (
        providerPermissions?.length ||
        memberPermissions?.length ||
        sccfPermissions?.length ||
        claimNo?.length
      ) {
        setCheckMinSearchCriteriaExplicitely(false);
      } else {
        setCheckMinSearchCriteriaExplicitely(true);
      }
    }, 0);

    return () => {
      clearTimeout(checkTimeout);
    };
  }, [
    providerPermissionsListArray,
    memberPermissionsListArray,
    sccfPermissionsListArray,
    claimnoPermissionsListArray,
    //defaultCalculated,
  ]);

  useEffect(() => {
    validateMinSearchCriteria();
  }, [selectedMemberDataLocal, selectedProviderDataLocal]);

  return (
    <div>
      <Container fluid className="manage-claims">
        <Row>
          <Col>
            <Header
              linkTo={'/admin/admin-dashboard'}
              header={t('admin.pages.manage_claims.module')}
              mandatoryLabel={
                <GenericButton
                  onClick={() => {
                    setSelectedCriteriaList([]);
                    setUserEnteredCriteriaValues({});
                    setProviderDetailsToSearch({});
                    setTotalDateInputsSelected(1);
                    providerDefault();
                    memberDefault();
                  }}
                  variant="link"
                  className="reset-claims-serach-filters"
                >
                  Reset
                </GenericButton>
              }
            />
          </Col>
        </Row>
        {checkMinSearchCriteriaExplicitely && (
          <CriteriaSelectableComponentWrapper
            showDeleteIcon={false}
            wrapperClassName="mt-3"
          >
            <>
              <InputsBlockHeading
                label={'Primary Search Criteria'}
                subText="Select at least one Primary Search Criteria. To narrow down your search, you can define additional search criteria."
              />
              <div className="options-list-container d-flex">
                <AddButton
                  label="Claim Number"
                  className={`add-button-active ${
                    selectedCriteriaList?.filter(
                      (item) => item?.value === 'claim-number',
                    )?.length > 0
                      ? 'add-button-disabled'
                      : ''
                  }`}
                  containerClassName={'mr-3'}
                  onClick={() => {
                    handleMinSearchCriteriaBtnClick('claim-number');
                  }}
                />
                <AddButton
                  label="SCCF #"
                  className={`add-button-active ${
                    selectedCriteriaList?.filter(
                      (item) => item?.value === 'sccf',
                    )?.length > 0
                      ? 'add-button-disabled'
                      : ''
                  }`}
                  containerClassName={'mr-3'}
                  onClick={() => {
                    handleMinSearchCriteriaBtnClick('sccf');
                  }}
                />
                <AddButton
                  label="Member/Dependent"
                  className={`add-button-active ${
                    selectedCriteriaList?.filter(
                      (item) => item?.value === 'member-information',
                    )?.length > 0
                      ? 'add-button-disabled'
                      : ''
                  }`}
                  containerClassName={'mr-3'}
                  onClick={() => {
                    handleMinSearchCriteriaBtnClick('member-information');
                  }}
                />
                <AddButton
                  label="Providers"
                  className={`add-button-active ${
                    selectedCriteriaList?.filter(
                      (item) => item?.value === 'provider-information',
                    )?.length > 0
                      ? 'add-button-disabled'
                      : ''
                  }`}
                  containerClassName={'mr-3'}
                  onClick={() => {
                    handleMinSearchCriteriaBtnClick('provider-information');
                  }}
                />
              </div>
            </>
          </CriteriaSelectableComponentWrapper>
        )}
        <form onSubmit={searchClaims}>
          <div className="m-0 my-3">
            {/*criteria components here */}
            {selectedCriteriaList.map((criteria) => {
              if (valuesList[criteria.value]) {
                return (
                  <CriteriaSelectableComponentWrapper
                    key={criteria.value}
                    handleDeleteCriteria={() => {
                      handleDeleteCriteria(criteria.value);
                    }}
                  >
                    <>
                      <InputsBlockHeading label={criteria.label} />
                      <div className="options-list-container">
                        <Row className="mx-0 px-0">
                          {valuesList[criteria.value].map((item) => {
                            //todo checked and unchecked logic
                            const isChecked =
                              userEnteredCriteriaValues[
                                criteria.value
                              ]?.findIndex((v) => v.value === item.value) > -1;
                            return (
                              <Col
                                className="px-0 mx-0 option-item"
                                key={item.value}
                                md={2}
                              >
                                <CheckboxInput
                                  name={`${criteria.value}`}
                                  value={item.value}
                                  label={item.label}
                                  onChange={(e) => {
                                    handleUserInputForSearchCriteria(
                                      criteria.value,
                                      criteria.value,
                                      //e.target.value,
                                      item,
                                      e.target.checked,
                                    );
                                  }}
                                  checked={isChecked}
                                />
                              </Col>
                            );
                          })}
                        </Row>
                      </div>
                    </>
                  </CriteriaSelectableComponentWrapper>
                );
              }

              if (criteria.value === 'claim-number') {
                return (
                  <CriteriaSelectableComponentWrapper
                    key={criteria.value}
                    handleDeleteCriteria={() => {
                      handleDeleteCriteria(criteria.value);
                    }}
                    showDeleteIcon={claimnoPermissionsListArray?.length === 0}
                  >
                    <>
                      <InputsBlockHeading label={criteria.label} />
                      <div className="options-list-container">
                        <Row className="mx-0">
                          <Col md={6} className="pl-0">
                            <TextInput
                              inputProps={{
                                isInvalid: false,
                                placeholder: 'Search by Claim number',
                                className: 'border-0',
                                name: 'claim-number',
                                onChange: (e) => {
                                  handleUserInputForSearchCriteria(
                                    'claim-number',
                                    'claim-number',
                                    e.target.value,
                                  );
                                },
                                onBlur: (e) => {
                                  handleUserInputForSearchCriteria(
                                    'claim-number',
                                    'claim-number',
                                    e.target.value,
                                  );
                                },
                                value:
                                  userEnteredCriteriaValues['claim-number'] ||
                                  '',
                              }}
                              label={'Search Claim'}
                              append={
                                <InputGroup.Text>
                                  <SearchSVG />
                                </InputGroup.Text>
                              }
                              isRequired={claimnoPermissionsListArray.includes(
                                'claim-number',
                              )}
                              feedBackMessage={
                                claimnoPermissionsListArray.includes(
                                  'claim-number',
                                ) &&
                                userEnteredCriteriaValues['claim-number']
                                  ?.length === 0
                                  ? 'Enter Claim Number'
                                  : ''
                              }
                            />
                          </Col>
                        </Row>
                      </div>
                    </>
                  </CriteriaSelectableComponentWrapper>
                );
              }

              if (criteria.value === 'sccf') {
                return (
                  <CriteriaSelectableComponentWrapper
                    key={criteria.value}
                    handleDeleteCriteria={() => {
                      handleDeleteCriteria(criteria.value);
                    }}
                    showDeleteIcon={sccfPermissionsListArray.length === 0}
                  >
                    <>
                      <InputsBlockHeading label={criteria.label} />
                      <div className="options-list-container">
                        <Row className="mx-0">
                          <Col md={6} className="pl-0">
                            <TextInput
                              inputProps={{
                                isInvalid: false,
                                placeholder: 'Enter SCCF number',
                                className: 'border-0',
                                value:
                                  userEnteredCriteriaValues[criteria.value],
                                onChange: (e) => {
                                  handleUserInputForSearchCriteria(
                                    criteria.value,
                                    criteria.value,
                                    e.target.value,
                                  );
                                },
                                onBlur: (e) => {
                                  handleUserInputForSearchCriteria(
                                    criteria.value,
                                    criteria.value,
                                    e.target.value,
                                  );
                                },
                              }}
                              label={'SCCF'}
                              isRequired={sccfPermissionsListArray.includes(
                                'sccf',
                              )}
                              feedBackMessage={
                                memberPermissionsListArray.includes('sccf') &&
                                userEnteredCriteriaValues[criteria.value]
                                  ?.length === 0
                                  ? 'Enter SCCF'
                                  : ''
                              }
                              footerLabel={'Example: GHP100909HP99'}
                            />
                          </Col>
                        </Row>
                      </div>
                    </>
                  </CriteriaSelectableComponentWrapper>
                );
              }

              if (criteria.value === 'member-information') {
                return (
                  <>
                    {selectedMemberDataLocal?.length === 0 ? (
                      <Row className="search-main-header m-0 my-3 p-0">
                        <Col
                          md={11}
                          sm={11}
                          lg={11}
                          className="pl-0 provider-info-container"
                        >
                          <h4 className="heading-text mb-3">
                            Member/Dependent
                            {(permissionForMemberSearch ||
                              memberPermissionsListArray?.length) &&
                            !isSuperUser ? (
                              <sup className="text-danger">*</sup>
                            ) : null}
                          </h4>
                          <AddButton
                            label={'Select Member/Dependent'}
                            onClick={() => handleMemberButton()}
                            className={'add-button-active'}
                            ref={searchMemberBtnRef}
                          />
                        </Col>
                        {(isSuperUser ||
                          (!permissionForMemberSearch &&
                            !memberPermissionsListArray?.length)) && (
                          <>
                            <GenericButton
                              className="pl-0 pr-0 delete-cliteria-btn provider-info-delete-button"
                              variant="link"
                              onClick={() =>
                                handleDeleteCriteria(criteria.value)
                              }
                            >
                              <TrashIcon />
                            </GenericButton>
                          </>
                        )}
                      </Row>
                    ) : (
                      <>
                        <Row className="search-main-header m-0 my-3 p-0">
                          <Col
                            md={11}
                            sm={11}
                            lg={11}
                            className="pl-0 provider-info-container"
                          >
                            <h4 className="heading-text mb-3">
                              Member/Dependent
                              {permissionForMemberSearch && !isSuperUser ? (
                                <sup className="text-danger">*</sup>
                              ) : null}
                            </h4>
                            {selectedMemberDataLocal?.map((item, index) => (
                              <div className="physician-list-item" key={index}>
                                <MemberSelectedItemComponent
                                  item={item}
                                  isSearchScreen={true}
                                  makeDataClear={makeDataClearMember}
                                />
                              </div>
                            ))}
                          </Col>
                          {(isSuperUser ||
                            (!permissionForMemberSearch &&
                              !memberPermissionsListArray?.length)) && (
                            <>
                              <GenericButton
                                className="pl-0 pr-0 delete-cliteria-btn provider-info-delete-button"
                                variant="link"
                                onClick={() => {
                                  makeDataClearMember();
                                  handleDeleteCriteria(criteria.value);
                                }}
                              >
                                <TrashIcon />
                              </GenericButton>
                            </>
                          )}
                        </Row>
                      </>
                    )}
                  </>
                );
              }

              //provider information
              if (criteria.value === 'provider-information') {
                return (
                  <>
                    {selectedProviderDataLocal?.length === 0 ? (
                      <Row className="search-main-header m-0 my-3 p-0">
                        <Col
                          md={11}
                          sm={11}
                          lg={11}
                          className="pl-0 provider-info-container"
                        >
                          <h4 className="heading-text mb-3">
                            Provider
                            {permissionForProviderSearch && !isSuperUser && (
                              <sup className="text-danger">*</sup>
                            )}
                          </h4>

                          <AddButton
                            label={'Select Provider'}
                            onClick={() => handleProviderButton()}
                            className={'add-button-active'}
                            ref={searchProviderBtnRef}
                          />
                        </Col>
                        {(isSuperUser ||
                          (!permissionForProviderSearch &&
                            !providerPermissionsListArray?.length)) && (
                          <>
                            <GenericButton
                              className="pl-0 pr-0 delete-cliteria-btn provider-info-delete-button"
                              variant="link"
                              onClick={() =>
                                handleDeleteCriteria(criteria.value)
                              }
                            >
                              <TrashIcon />
                            </GenericButton>
                          </>
                        )}
                      </Row>
                    ) : (
                      <>
                        <Row className="search-main-header m-0 my-3 p-0">
                          <Col
                            md={11}
                            sm={11}
                            lg={11}
                            className="pl-0 provider-info-container"
                          >
                            <h4 className="heading-text mb-3">
                              Provider{' '}
                              {permissionForProviderSearch && !isSuperUser && (
                                <sup className="text-danger">*</sup>
                              )}
                            </h4>
                            {selectedProviderDataLocal?.map((item, index) => (
                              <div className="physician-list-item" key={index}>
                                <SelectedItemComponent
                                  item={item}
                                  isSearchScreen={true}
                                  makeDataClear={makeDataClearProvider}
                                />
                              </div>
                            ))}
                          </Col>
                          {(isSuperUser ||
                            (!permissionForProviderSearch &&
                              !providerPermissionsListArray?.length)) && (
                            <>
                              <GenericButton
                                className="pl-0 pr-0 delete-cliteria-btn provider-info-delete-button"
                                variant="link"
                                onClick={() => {
                                  makeDataClearProvider();
                                  handleDeleteCriteria(criteria.value);
                                }}
                              >
                                <TrashIcon />
                              </GenericButton>
                            </>
                          )}
                        </Row>
                      </>
                    )}
                  </>
                );
              }

              //claim date
              if (criteria.value === 'claim-date') {
                //claimDateSearchByOptions, claimDateDateRangeOptions
                return (
                  <CriteriaSelectableComponentWrapper
                    key={criteria.value}
                    handleDeleteCriteria={() => {
                      handleDeleteCriteria(criteria.value);
                    }}
                  >
                    <>
                      <InputsBlockHeading label={criteria.label} />

                      <div className="options-list-container">
                        {userEnteredCriteriaValues[criteria.value]?.map(
                          (memberValue, index) => {
                            const availableOptions =
                              claimDateSearchByOptions.filter(
                                (o) =>
                                  !selectedDateTypeValues.includes(o.value),
                              );
                            const defaultSelectedValue = availableOptions[0];
                            if (!memberValue?.type?.value) {
                              handleClaimDateValueChange(
                                'type',
                                defaultSelectedValue,
                                index,
                                true,
                              );
                            }
                            return (
                              <Row className="mx-0" key={`claim-date-${index}`}>
                                {/*<Col md={11} className="m-0 p-0">
                                <Row className="m-0 p-0">*/}
                                <Col
                                  md={3}
                                  className="member-info-input-block pl-0"
                                >
                                  <label className="provider-select-input-label">
                                    {'Search By'}
                                  </label>

                                  <AutoSuggestionSelectComponent
                                    options={availableOptions}
                                    name="dateType"
                                    placeholder="Select date type"
                                    components={{
                                      IndicatorSeparator: () => null,
                                    }}
                                    value={
                                      memberValue.type?.value
                                        ? memberValue.type
                                        : availableOptions[0]
                                    }
                                    onChange={(e) => {
                                      handleClaimDateValueChange(
                                        'type',
                                        e,
                                        index,
                                      );
                                    }}
                                    isSearchable={false}
                                  />
                                </Col>

                                <Col
                                  md={3}
                                  className="member-info-input-block pl-0"
                                >
                                  <label className="provider-select-input-label">
                                    {'Date Range'}
                                  </label>

                                  <AutoSuggestionSelectComponent
                                    options={claimDateDateRangeOptions}
                                    name="dateType"
                                    placeholder="Select duration"
                                    components={{
                                      IndicatorSeparator: () => null,
                                    }}
                                    value={memberValue.date_range}
                                    onChange={(e) => {
                                      handleClaimDateValueChange(
                                        'date_range',
                                        e,
                                        index,
                                      );
                                    }}
                                    isSearchable={false}
                                  />
                                </Col>
                                {memberValue.date_range?.value ===
                                  'custom-date' && (
                                  <>
                                    <Col
                                      md={4}
                                      className="member-info-input-block pl-0"
                                    >
                                      <label className="provider-select-input-label">
                                        Effective Duration
                                      </label>

                                      <DatePicker
                                        allowFutureDates={true}
                                        selectsRange={true}
                                        startDate={memberValue.from_date || ''}
                                        endDate={memberValue.to_date || ''}
                                        onChange={(update) => {
                                          if (update[0]) {
                                            handleClaimDateValueChange(
                                              'from_date',
                                              update[0],
                                              index,
                                            );
                                          }
                                          if (update[1]) {
                                            handleClaimDateValueChange(
                                              'to_date',
                                              update[1],
                                              index,
                                            );
                                          }
                                        }}
                                        onChangeRaw={(e) => {
                                          if (e.target.value) {
                                            const dates = e.target.value
                                              .split(' - ')
                                              .map((date) => {
                                                const d = new Date(date);
                                                return d;
                                              });
                                            if (moment(dates[0]).isValid()) {
                                              handleClaimDateValueChange(
                                                'from_date',
                                                dates[0],
                                                index,
                                              );
                                            }
                                            if (
                                              moment(dates[1]).isValid() &&
                                              moment(dates[0]) <
                                                moment(dates[1])
                                            ) {
                                              handleClaimDateValueChange(
                                                'to_date',
                                                dates[1],
                                                index,
                                              );
                                            }
                                          }
                                        }}
                                        showIcon={true}
                                        placeholder={
                                          Default_Time_Format +
                                          ' - ' +
                                          Default_Time_Format
                                        }
                                      />
                                    </Col>

                                    {/*<Col
                                    md={3}
                                    className="member-info-input-block1 pl-0"
                                  >
                                    <label className="provider-select-input-label">
                                      {'To'}
                                    </label>

                                    <DatePicker
                                      //placeholder={'To Date'}
                                      onChange={(e) => {
                                        handleClaimDateValueChange(
                                          'to_date',
                                          e,
                                          index,
                                        );
                                      }}
                                      value={memberValue.to_date || ''}
                                      disabled={
                                        memberValue.date_range?.value !==
                                        'custom-date'
                                      }
                                      minDate={memberValue.from_date || null}
                                      //maxDate={new Date()}
                                      maxDate={new Date()}
                                      showIcon={true}
                                    />
                                  </Col> */}
                                  </>
                                )}
                                <Col className=" icon-class pl-0">
                                  <GenericButton
                                    onClick={() => {
                                      handleDeleteDate(index);
                                    }}
                                    variant={'link'}
                                  >
                                    {' '}
                                    <CrossIcon />
                                  </GenericButton>
                                </Col>
                              </Row>
                            );
                          },
                        )}

                        {/*{selectedDateTypeValues.length <
                        claimDateSearchByOptions.length && (*/}
                        {totalDateInputsSelected < 4 && (
                          <GenericButton
                            className="pl-0 add-more-member-btn add-more-provider-btn"
                            variant="link"
                            onClick={handleAddMoreClaimDate}
                          >
                            + Add Date
                          </GenericButton>
                        )}
                      </div>
                    </>
                  </CriteriaSelectableComponentWrapper>
                );
              }
            })}
          </div>

          {selectedCriteriaList?.length < criteriaMenuItems?.length ? (
            <Row className="m-0">
              <Col className="p-0" md={3}>
                <ActionMenus
                  ref={actionMenuRef}
                  MenuLabelComponent={() => (
                    <GenericButton
                      className="pl-0 add-search-criteria-btn"
                      variant="link"
                      onClick={() => {}}
                    >
                      + Additional Search Criteria
                    </GenericButton>
                  )}
                  containerClassName="criteria-menu-container border-0"
                  menuItemContainerClassName="criteria-menu-item-container"
                  menuItems={criteriaMenuItems.map((menu) => {
                    if (
                      selectedCriteriaList.findIndex(
                        (c) => c.value === menu.value,
                      ) < 0
                    ) {
                      return () => (
                        <ActionMenuItem
                          label={menu.label}
                          onClick={() => {
                            handleAddCriteria(menu);
                          }}
                        />
                      );
                    } else {
                      return () => <></>;
                    }
                  })}
                />
              </Col>
            </Row>
          ) : null}

          <Row>
            <Col md={12} className="text-right">
              <GenericButton
                className="pl-0 cancel-button"
                variant="link"
                onClick={() => {
                  navigate('/admin/admin-dashboard');
                }}
              >
                Cancel
              </GenericButton>
              <CommonGenericButton
                className="abc"
                buttonDisabled={isSearchBtnDisable}
                variant="primary"
                disable={isSearchBtnDisable}
                type={'submit'}
              >
                Search
              </CommonGenericButton>
            </Col>
          </Row>
        </form>
      </Container>

      <FilterModal
        showBackButton={false}
        isVisible={openProviderModal}
        onHide={() => {
          setOpenProviderModal(false);
          setSelectedProviderDataLocal([]);
          makeDataClearProvider();
        }}
        applyFilterHandler={() => {
          setOpenProviderModal(false);
          setSelectedProviderDataLocal(
            providerListDataLocal?.filter((item) => item?.isChecked === true),
          );
        }}
        showCancel={true}
        titleLabel="Providers"
        showApply={true}
        showApplyLabel="Add Selected"
        customClasses="provider-selection-modal-claims"
        isDisabled={
          providerListDataLocal?.filter((item) => item?.isChecked === true)
            .length === 0
        }
        postLabel="ADD SELECTED"
      >
        <Container className="mt-3 mb-3">
          {openProviderModal && (
            <>
              <Row>
                {userEnteredCriteriaValues['provider-information']?.map(
                  (memberValue, index) => {
                    return (
                      <>
                        <Row>
                          <Col className="mb-3">
                            <p className="modal-min-search-req-title member-info-input-block pr-2 col-md-12">
                              The minimum search criteria for Providers is
                              Physician Name or Specialty or NPI or Tax ID and
                              any other field that is marked as mandatory.
                            </p>
                          </Col>
                        </Row>
                        <Row
                          className="mx-0"
                          key={`provider-information-${index}`}
                        >
                          <Col
                            md={6}
                            className="member-info-input-block pr-2 mb-3"
                          >
                            <TextInput
                              inputProps={{
                                isInvalid: false,
                                placeholder: 'Enter Physician Name',
                                className: 'border-0',
                                value: memberValue.name,
                                name: 'name',
                                onChange: (e) => {
                                  handleProviderValueChange(
                                    'name',
                                    e.target.value,
                                    index,
                                  );
                                },
                                onBlur: (e) => {
                                  handleProviderValueChange(
                                    'name',
                                    e.target.value,
                                    index,
                                  );
                                },
                              }}
                              isRequired={providerPermissionsListArray.includes(
                                'name',
                              )}
                              label={'Physician Name'}
                              feedBackMessage={
                                providerPermissionsListArray.includes('name') &&
                                memberValue.name?.length === 0
                                  ? 'Enter Physician Name'
                                  : ''
                              }
                            />
                          </Col>
                          <Col
                            md={6}
                            className="member-info-input-block pl-2 mb-3"
                          >
                            <TextInput
                              inputProps={{
                                isInvalid: false,
                                placeholder: 'Enter facility name',
                                className: 'border-0',
                                value: memberValue.facility_name,
                                onChange: (e) => {
                                  handleProviderValueChange(
                                    'facility_name',
                                    e.target.value,
                                    index,
                                  );
                                },
                                onBlur: (e) => {
                                  handleProviderValueChange(
                                    'facility_name',
                                    e.target.value,
                                    index,
                                  );
                                },
                              }}
                              isRequired={providerPermissionsListArray.includes(
                                'facility_name',
                              )}
                              label={'Facility Name'}
                              feedBackMessage={
                                providerPermissionsListArray.includes(
                                  'facility_name',
                                ) && memberValue.facility_name?.length === 0
                                  ? 'Enter Facility name'
                                  : ''
                              }
                            />
                          </Col>
                          <Col
                            md={6}
                            className="member-info-input-block pr-2 mb-3"
                          >
                            <TextInput
                              inputProps={{
                                isInvalid: false,
                                placeholder: 'Enter NPI',
                                className: 'border-0',
                                value: memberValue.npi,
                                onChange: (e) => {
                                  handleProviderValueChange(
                                    'npi',
                                    e.target.value,
                                    index,
                                  );
                                },
                                onBlur: (e) => {
                                  handleProviderValueChange(
                                    'npi',
                                    e.target.value,
                                    index,
                                  );
                                },
                              }}
                              isRequired={providerPermissionsListArray.includes(
                                'npi',
                              )}
                              label={'NPI'}
                              feedBackMessage={
                                providerPermissionsListArray.includes('npi') &&
                                memberValue.npi?.length === 0
                                  ? 'Enter NPI'
                                  : ''
                              }
                            />
                          </Col>
                          <Col
                            md={6}
                            className="member-info-input-block pl-2 mb-3"
                          >
                            <TextInput
                              inputProps={{
                                isInvalid: false,
                                placeholder: 'Enter Tax ID',
                                className: 'border-0',
                                value: memberValue.tax_id,
                                onChange: (e) => {
                                  handleProviderValueChange(
                                    'tax_id',
                                    e.target.value,
                                    index,
                                  );
                                },
                                onBlur: (e) => {
                                  handleProviderValueChange(
                                    'tax_id',
                                    e.target.value,
                                    index,
                                  );
                                },
                              }}
                              isRequired={providerPermissionsListArray.includes(
                                'tax_id',
                              )}
                              label={'Tax ID'}
                              feedBackMessage={
                                providerPermissionsListArray.includes(
                                  'tax_id',
                                ) && memberValue.tax_id?.length === 0
                                  ? 'Enter Tax ID'
                                  : ''
                              }
                            />
                          </Col>
                          <Col
                            md={6}
                            className="member-info-input-block pr-2 generic-text-input-wrapper mb-3"
                          >
                            <label className="mb-0">
                              Specialty
                              {providerPermissionsListArray.includes(
                                'specialty',
                              ) ? (
                                <span className="mandatory-field"> *</span>
                              ) : (
                                ''
                              )}
                            </label>

                            <SpecialtySelectInput
                              onChangeHandler={(e) => {
                                handleProviderValueChange(
                                  'specialty',
                                  e,
                                  index,
                                );
                              }}
                              isRequired={providerPermissionsListArray.includes(
                                'specialty',
                              )}
                              value={memberValue.specialty?.value}
                              onBlur={(e) => {
                                handleProviderValueChange(
                                  'specialty',
                                  e,
                                  index,
                                );
                              }}
                            />
                          </Col>
                          <Col
                            md={6}
                            className="member-info-input-block pl-2 mb-3"
                          >
                            <TextInput
                              inputProps={{
                                isInvalid: false,
                                placeholder: 'City',
                                className: 'border-0',
                                value: memberValue.city,
                                onChange: (e) => {
                                  handleProviderValueChange(
                                    'city',
                                    e.target.value,
                                    index,
                                  );
                                },
                                onBlur: (e) => {
                                  handleProviderValueChange(
                                    'city',
                                    e.target.value,
                                    index,
                                  );
                                },
                              }}
                              isRequired={providerPermissionsListArray.includes(
                                'city',
                              )}
                              label={'City'}
                              feedBackMessage={
                                providerPermissionsListArray.includes('city') &&
                                memberValue.city?.length === 0
                                  ? 'Enter City'
                                  : ''
                              }
                            />
                          </Col>
                          <Col
                            md={6}
                            className="member-info-input-block pr-2 mb-3"
                          >
                            <TextInput
                              inputProps={{
                                isInvalid: false,
                                placeholder: 'State',
                                className: 'border-0',
                                value: memberValue.state,
                                onChange: (e) => {
                                  handleProviderValueChange(
                                    'state',
                                    e.target.value,
                                    index,
                                  );
                                },
                                onBlur: (e) => {
                                  handleProviderValueChange(
                                    'state',
                                    e.target.value,
                                    index,
                                  );
                                },
                              }}
                              isRequired={providerPermissionsListArray.includes(
                                'state',
                              )}
                              label={'State'}
                              feedBackMessage={
                                providerPermissionsListArray.includes(
                                  'state',
                                ) && memberValue.state?.length === 0
                                  ? 'Enter State'
                                  : ''
                              }
                            />
                          </Col>
                          <Col
                            md={6}
                            className="member-info-input-block pl-2 mb-3"
                          >
                            <TextInput
                              inputProps={{
                                isInvalid: false,
                                placeholder: 'Zip Code',
                                className: 'border-0',
                                value: memberValue.zip_code,
                                onChange: (e) => {
                                  handleProviderValueChange(
                                    'zip_code',
                                    e.target.value,
                                    index,
                                  );
                                },
                                onBlur: (e) => {
                                  handleProviderValueChange(
                                    'zip_code',
                                    e.target.value,
                                    index,
                                  );
                                },
                              }}
                              isRequired={providerPermissionsListArray.includes(
                                'zip_code',
                              )}
                              label={'Zip Code'}
                              feedBackMessage={
                                providerPermissionsListArray.includes(
                                  'zip_code',
                                ) && memberValue.zip_code?.length === 0
                                  ? 'Enter State'
                                  : ''
                              }
                            />
                          </Col>
                          <Col
                            md={6}
                            className="member-info-input-block pr-2 mb-3"
                          >
                            <TextInput
                              inputProps={{
                                isInvalid: false,
                                placeholder: 'County',
                                className: 'border-0',
                                value: memberValue.county,
                                onChange: (e) => {
                                  handleProviderValueChange(
                                    'county',
                                    e.target.value,
                                    index,
                                  );
                                },
                                onBlur: (e) => {
                                  handleProviderValueChange(
                                    'county',
                                    e.target.value,
                                    index,
                                  );
                                },
                              }}
                              isRequired={providerPermissionsListArray.includes(
                                'county',
                              )}
                              label={'County'}
                              feedBackMessage={
                                providerPermissionsListArray.includes(
                                  'county',
                                ) && memberValue.county?.length === 0
                                  ? 'Enter State'
                                  : ''
                              }
                            />
                          </Col>
                        </Row>
                        <div className="ml-auto pr-3">
                          <GenericButton
                            className="provider-list-search-btn"
                            buttonDisabled={disableProviderSearchBtn}
                            variant="primary"
                            disable={disableProviderSearchBtn}
                            type={'submit'}
                            postLabel="SEARCH"
                            onClick={() => {
                              providerSearchAPI();
                            }}
                          >
                            Search
                          </GenericButton>
                        </div>
                        <Col sm={12}>
                          <ProviderSideModal
                            data={providerListDataLocal}
                            setSelectedProviderData={(data) => {
                              setSelectedProviderDataLocal(data);
                            }}
                            skeletonLoader={false}
                            isServerError={isServerError}
                            setProviderListData={setProviderListDataLocal}
                            makeDataClear={makeDataClearProvider}
                            dataFetching={dataFetching}
                          />
                        </Col>
                      </>
                    );
                  },
                )}
              </Row>
            </>
          )}
        </Container>
      </FilterModal>

      <FilterModal
        showBackButton={false}
        isVisible={openMemberModal}
        onHide={() => {
          setOpenMemberModal(false);
          setSelectedMemberDataLocal([]);
          makeDataClearMember();
        }}
        applyFilterHandler={() => {
          setOpenMemberModal(false);
          setSelectedMemberDataLocal(
            [...memberListDataLocal]?.filter(
              (item) => item?.isChecked === true,
            ),
          );
        }}
        showCancel={true}
        titleLabel="Member/Dependent"
        showApply={true}
        showApplyLabel="Add Selected"
        customClasses="member-selection-modal-claims"
        isDisabled={
          memberListDataLocal?.filter((item) => item?.isChecked === true)
            .length === 0
        }
        postLabel="ADD SELECTED"
      >
        <Container className="mt-3 mb-3">
          <div className="options-list-container">
            {userEnteredCriteriaValues['member-information']?.map(
              (memberValue, i) => {
                return (
                  <>
                    <Row>
                      <Col className="mb-3 px-0">
                        <p className="modal-min-search-req-title member-info-input-block pr-2 col-md-12">
                          The minimum search criteria for Member is Member ID or
                          Last Name, and any other field that is marked as
                          mandatory.
                        </p>
                      </Col>
                    </Row>
                    <Row className="mx-0" key={`member-information-${i}`}>
                      {/*{userEnteredCriteriaValues['member-information']?.length >
                      1 ? (
                        <Col md={12} className="pl-0">
                          <label className="member-num-label">
                            Member {i + 1}
                          </label>
                        </Col>
                      ) : null} */}

                      <Col
                        md={6}
                        className="member-info-input-block pl-0 pr-2 mb-3"
                      >
                        <TextInput
                          inputProps={{
                            isInvalid: false,
                            placeholder: 'Enter member first name',
                            className: 'border-0',
                            value: memberValue.first_name || '',
                            onChange: (e) => {
                              handleUserInputForSearchCriteria(
                                'member-information',
                                'first_name',
                                e.target.value,
                                null,
                                i,
                              );
                            },
                            onBlur: (e) => {
                              handleUserInputForSearchCriteria(
                                'member-information',
                                'first_name',
                                e.target.value,
                                null,
                                i,
                              );
                            },
                          }}
                          label={'First Name'}
                          isRequired={memberPermissionsListArray.includes(
                            'first_name',
                          )}
                          feedBackMessage={
                            memberPermissionsListArray.includes('first_name') &&
                            memberValue.first_name?.length === 0
                              ? 'Enter First Name'
                              : ''
                          }
                        />
                      </Col>
                      <Col
                        md={6}
                        className="member-info-input-block pl-2 pr-0 mb-3"
                      >
                        <TextInput
                          inputProps={{
                            isInvalid: false,
                            placeholder: 'Enter member last name',
                            className: 'border-0',
                            value: memberValue.last_name || '',
                            onChange: (e) => {
                              handleUserInputForSearchCriteria(
                                'member-information',
                                'last_name',
                                e.target.value,
                                null,
                                i,
                              );
                            },
                            onBlur: (e) => {
                              handleUserInputForSearchCriteria(
                                'member-information',
                                'last_name',
                                e.target.value,
                                null,
                                i,
                              );
                            },
                          }}
                          label={'Last Name'}
                          isRequired={memberPermissionsListArray.includes(
                            'last_name',
                          )}
                          feedBackMessage={
                            memberPermissionsListArray.includes('last_name') &&
                            memberValue.last_name?.length === 0
                              ? 'Enter Last Name'
                              : ''
                          }
                        />
                      </Col>

                      <Col
                        md={6}
                        className="member-info-input-block pl-0 pr-2 mb-3"
                      >
                        <TextInput
                          inputProps={{
                            isInvalid: false,
                            placeholder: 'Enter ID here',
                            className: 'border-0',
                            value: memberValue.member_id || '',
                            onChange: (e) => {
                              handleUserInputForSearchCriteria(
                                'member-information',
                                'member_id',
                                e.target.value,
                                null,
                                i,
                              );
                            },
                            onBlur: (e) => {
                              handleUserInputForSearchCriteria(
                                'member-information',
                                'member_id',
                                e.target.value,
                                null,
                                i,
                              );
                            },
                          }}
                          label={'Member ID / SSN / ALT ID 1 / ALT ID 2'}
                          isRequired={memberPermissionsListArray.includes(
                            'member_id',
                          )}
                          feedBackMessage={
                            memberPermissionsListArray.includes('member_id') &&
                            memberValue.member_id?.length === 0
                              ? 'Enter Member ID'
                              : ''
                          }
                        />
                      </Col>

                      <Col
                        md={6}
                        className="member-info-input-block pl-2 pr-0 mb-3"
                      >
                        {/*<TextInput inputProps={{ isInvalid: false, "data-date": "", "data-date-format": "mm/dd/YY", placeholder: "MM/DD/YYYY", className: "border-0", type: 'date', readonly: true, spellCheck: "off", autoCorrect: "off", autoComplete: "off", value: memberValue.dob, onChange: (e) => { handleUserInputForSearchCriteria('member-information', 'dob', e.target.value, null, i) } }} label={'DOB'} /> */}

                        <label className="provider-select-input-label datpicker-label">
                          {'DOB'}
                          {memberPermissionsListArray.includes('dob') ? (
                            <span className="mandatory-field"> *</span>
                          ) : (
                            ''
                          )}
                        </label>

                        <DatePicker
                          maxYearRange={100}
                          placeholder={Default_Time_Format || 'MM/DD/YYYY'}
                          onChange={(e) => {
                            handleUserInputForSearchCriteria(
                              'member-information',
                              'dob',
                              e,
                              null,
                              i,
                            );
                          }}
                          onBlur={(e) => {
                            handleUserInputForSearchCriteria(
                              'member-information',
                              'dob',
                              e,
                              null,
                              i,
                            );
                          }}
                          value={
                            memberValue.dob ? new Date(memberValue.dob) : ''
                          }
                          showIcon={true}
                          isRequired={memberPermissionsListArray.includes(
                            'dob',
                          )}
                        />
                      </Col>

                      {/*<Col // as patient control number is not applicable here we are commenting this
                        md={12}
                        className="member-info-input-block pl-0 pr-0"
                      >
                        <TextInput
                          inputProps={{
                            isInvalid: false,
                            placeholder: 'Enter Patient Control Number here',
                            className: 'border-0',
                            value: memberValue.patient_control_number || '',
                            onChange: (e) => {
                              handleUserInputForSearchCriteria(
                                'member-information',
                                'patient_control_number',
                                e.target.value,
                                null,
                                i,
                              );
                            },
                          }}
                          label={'Patient Control Number'}
                        />
                      </Col> */}
                    </Row>
                    <div className="ml-auto text-right pr-3 pt-3">
                      <GenericButton
                        className="member-list-search-btn"
                        buttonDisabled={isMemberSearchBtnDisable}
                        variant="primary"
                        disable={isMemberSearchBtnDisable}
                        type={'submit'}
                        postLabel="SEARCH"
                        onClick={() => {
                          memberSearchAPI();
                        }}
                      >
                        Search
                      </GenericButton>
                    </div>
                    <Row>
                      <Col sm={12}>
                        <MemberSideModal
                          data={memberListDataLocal}
                          skeletonLoader={false}
                          setMemberListData={setMemberListDataLocal}
                          makeDataClear={makeDataClearMember}
                          isServerError={isServerError}
                          dataFetching={dataFetching}
                        />
                      </Col>
                    </Row>
                  </>
                );
              },
            )}
          </div>
        </Container>
      </FilterModal>

      <div className="toastify">
        <ToastContainer
          draggable
          pauseOnHover
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          autoClose={5000}
          position="top-center"
          newestOnTop={false}
          hideProgressBar={false}
          className="toastcontainer"
        />
      </div>
    </div>
  );
};

export default withTranslation()(ManageClaims);
